import { defineMessages } from '../define';

/** Group chats (Spjall) and the notification bell (Tilkynningar). */
export const chat = defineMessages(
  {
    'chat.title': 'Spjall',
    'chat.name.choir': 'Kórspjall',
    'chat.desc.choir': 'Allur kórinn',
    'chat.desc.voice': 'Raddspjall',
    'chat.list.mine': 'Mín spjöll',
    'chat.list.others': 'Aðrar raddir',
    'chat.list.others_hint': 'Þú sérð spjall allra radda og getur skrifað þar.',
    'chat.list.help': 'Allir félagar sjá kórspjallið. Raddspjall sjá félagar raddarinnar ásamt stjórnanda.',
    'chat.list.no_messages': 'Engin skilaboð enn',
    'chat.list.load_error': 'Ekki tókst að sækja spjöllin.',
    'chat.you': 'Þú',
    'chat.unread': { one: '{count} ólesin', other: '{count} ólesin' },
    'chat.muted': 'Tilkynningar þaggaðar',
    'chat.mute': 'Þagga tilkynningar',
    'chat.mute_short': 'Þagga',
    'chat.muted_done': 'Þú færð ekki tilkynningar úr þessu spjalli.',
    'chat.unmuted_done': 'Þú færð tilkynningar úr þessu spjalli.',
    'chat.placeholder': 'Skrifa skilaboð…',
    'chat.send': 'Senda',
    'chat.empty': 'Engin skilaboð enn. Skrifaðu fyrstu skilaboðin!',
    'chat.new_divider': 'Ný skilaboð',
    'chat.load_older': 'Sýna eldri skilaboð',
    'chat.load_error': 'Ekki tókst að sækja skilaboð.',
    'chat.not_found': 'Þetta spjall er ekki til eða þú hefur ekki aðgang að því.',
    'chat.messages': 'Skilaboð',
    'chat.reply': 'Svara',
    'chat.replying_to': 'Svar til {name}',
    'chat.cancel_reply': 'Hætta við svar',
    'chat.edited': 'breytt',
    'chat.deleted': 'Skilaboðum eytt',
    'chat.left': '(hættur)',
    'chat.delete_title': 'Eyða skilaboðum?',
    'chat.delete_body': 'Skilaboðin hverfa úr spjallinu hjá öllum.',
    'chat.sending': 'Sendi…',
    'chat.queued': 'Bíður eftir neti',
    'chat.failed': 'Ekki sent',
    'chat.discard': 'Henda',
    'chat.saved_offline': 'Vistað – sent þegar netið kemst á',
    'chat.rejected': 'Ekki sent: skilaboðin sem þú skrifaðir án nettengingar voru ekki tekin gild.',
    'chat.actions_for': 'Skilaboð frá {name}',
    'chat.jump_latest': 'Nýjustu skilaboð',

    'notify.title': 'Tilkynningar',
    'notify.open': 'Tilkynningar',
    'notify.open_unread': { one: 'Tilkynningar, {count} ólesin skilaboð', other: 'Tilkynningar, {count} ólesin skilaboð' },
    'notify.empty_title': 'Ekkert nýtt',
    'notify.empty': 'Hér birtast ný skilaboð við viðburði og í spjalli kórsins.',
    'notify.mark_all': 'Merkja allt lesið',
    'notify.mark_all_error': 'Ekki tókst að merkja lesið.',
    'notify.load_error': 'Ekki tókst að sækja tilkynningar.',
    'notify.and': 'og',
    'notify.others': { one: '{count} annar', other: '{count} aðrir' },
    'notify.wrote_event_one': '{names} skrifaði á {event}',
    'notify.wrote_event_many': '{names} skrifuðu á {event}',
    'notify.wrote_chat_one': '{names} skrifaði í {chat}',
    'notify.wrote_chat_many': '{names} skrifuðu í {chat}',
    'notify.event_label': '{title} ({day})',
    'notify.in_choir': 'kórspjallið',
    'notify.in_voice': 'spjall {voice}',
    'notify.new_count': { one: '{count} nýtt', other: '{count} ný' },
    'notify.go_chats': 'Opna spjall',
  },
  {
    'chat.title': 'Chat',
    'chat.name.choir': 'Choir chat',
    'chat.desc.choir': 'The whole choir',
    'chat.desc.voice': 'Section chat',
    'chat.list.mine': 'My chats',
    'chat.list.others': 'Other sections',
    'chat.list.others_hint': 'You can read and write in every section’s chat.',
    'chat.list.help': 'Every member sees the choir chat. A section chat is seen by that section and the conductor.',
    'chat.list.no_messages': 'No messages yet',
    'chat.list.load_error': 'Could not load the chats.',
    'chat.you': 'You',
    'chat.unread': { one: '{count} unread', other: '{count} unread' },
    'chat.muted': 'Notifications muted',
    'chat.mute': 'Mute notifications',
    'chat.mute_short': 'Mute',
    'chat.muted_done': 'You will not be notified about this chat.',
    'chat.unmuted_done': 'You will be notified about this chat.',
    'chat.placeholder': 'Write a message…',
    'chat.send': 'Send',
    'chat.empty': 'No messages yet. Write the first one!',
    'chat.new_divider': 'New messages',
    'chat.load_older': 'Show older messages',
    'chat.load_error': 'Could not load messages.',
    'chat.not_found': 'This chat does not exist or you do not have access to it.',
    'chat.messages': 'Messages',
    'chat.reply': 'Reply',
    'chat.replying_to': 'Replying to {name}',
    'chat.cancel_reply': 'Cancel reply',
    'chat.edited': 'edited',
    'chat.deleted': 'Message deleted',
    'chat.left': '(left)',
    'chat.delete_title': 'Delete message?',
    'chat.delete_body': 'The message will be removed from the chat for everyone.',
    'chat.sending': 'Sending…',
    'chat.queued': 'Waiting for connection',
    'chat.failed': 'Not sent',
    'chat.discard': 'Discard',
    'chat.saved_offline': 'Saved – will be sent when you are back online',
    'chat.rejected': 'Not sent: the message you wrote while offline was not accepted.',
    'chat.actions_for': 'Message from {name}',
    'chat.jump_latest': 'Latest messages',

    'notify.title': 'Notifications',
    'notify.open': 'Notifications',
    'notify.open_unread': { one: 'Notifications, {count} unread message', other: 'Notifications, {count} unread messages' },
    'notify.empty_title': 'Nothing new',
    'notify.empty': 'New messages on events and in the choir’s chats show up here.',
    'notify.mark_all': 'Mark all as read',
    'notify.mark_all_error': 'Could not mark as read.',
    'notify.load_error': 'Could not load notifications.',
    'notify.and': 'and',
    'notify.others': { one: '{count} other', other: '{count} others' },
    'notify.wrote_event_one': '{names} commented on {event}',
    'notify.wrote_event_many': '{names} commented on {event}',
    'notify.wrote_chat_one': '{names} wrote in {chat}',
    'notify.wrote_chat_many': '{names} wrote in {chat}',
    'notify.event_label': '{title} ({day})',
    'notify.in_choir': 'the choir chat',
    'notify.in_voice': 'the {voice} chat',
    'notify.new_count': { one: '{count} new', other: '{count} new' },
    'notify.go_chats': 'Open chat',
  },
);
